<script setup lang="ts">
defineProps({
  alignCenter: {
    type: Boolean,
    default: false,
  },

  alignSpaceBetween: {
    type: Boolean,
    default: false,
  },

  omitPadding: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div
    :class="[
      'key-value-pair-container-row',
      $style.container,
      omitPadding && $style.omitPadding,
      omitPadding && 'key-value-pair-container-row-omit-padding',
      alignCenter && $style.alignCenter,
      alignSpaceBetween && $style.alignSpaceBetween,
    ]"
  >
    <slot />
  </div>
</template>

<style module>
.container {
  display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  padding: 0.5rem;
  overflow-x: auto;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-color: var(--color-accent-300) var(--color-white);
  scrollbar-width: thin;
}

.container.alignSpaceBetween {
  justify-content: space-between;
}

.omitPadding {
  padding: 0;
}

.alignCenter {
  align-content: center;
}

.container::-webkit-scrollbar {
  height: 1rem;
}

.container::-webkit-scrollbar-track {
  background: var(--color-white);
}

.container::-webkit-scrollbar-thumb {
  background-color: var(--color-accent-300);
  border-radius: calc(1rem - var(--border-radius-medium));
  border: 0.25rem solid var(--color-white);
}

.container::-webkit-scrollbar-thumb:hover {
  border-width: 0.2rem;
}

:global(.key-value-pair-container-row .key-value-pair) {
  margin: 0.5rem;
  margin-right: 2.5rem;
}

:global(.key-value-pair-container-row-omit-padding .key-value-pair) {
  margin: 0;
  margin-right: 2.5rem !important;
}

:global(.key-value-pair-container-row .key-value-pair:last-child) {
  margin-right: 0;
}

:global(.key-value-pair-container-row-align-center) {
  justify-content: center;
}

:global(.key-value-pair-container-row-align-center .key-value-pair) {
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}
</style>
